import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { UserService } from "./user.service";
import { HttpHelperService } from './helpers/http-helper.service';
import { PromotionService } from "./promotion.service";

@Injectable()
export class AdminService {

	constructor(
		private http: Http,
		private userService: UserService,
		private httpHelperService: HttpHelperService,
		private promotionService: PromotionService
	) {}

	updateStaticContent(data) {
		return new Promise((resolve, reject) => {
			const body = data
			this.http.post('/api/admin/staticcontent', body, { headers: this.httpHelperService.headers(true, UserService.token) })
				.subscribe((res: any) => {
					const result = res.json()
					this.promotionService.promoMessageChanged.next(result)
					resolve(result)
				})
		})
	}

	getStaticContent(data: String) {
		const contentFor = data;
		return new Promise((resolve, reject) => {
			this.http.get('/api/admin/staticcontent/' + contentFor, {headers: this.httpHelperService.headers(false)})
				.subscribe((res: any) => {
					resolve(res.json())
				}, (err: any) => {
					reject(err);
				})
		})
	//  return new Promise((resolve, reject) => {
	// 	 const body = userData;
	// 	 this.http.post('/api/register', body, { headers: this.httpHelperService.headers(false) })
	// 		 // this.http.post('/api/register', body, { headers: this.httpHelperService.headers(true, this.registerToken() ) })
	// 		 .subscribe((res: any) => {
	// 			 var result = res.json()
	// 			 if (result) {
	// 				 resolve(result)
	// 			 } else {
	// 				 reject(result)
	// 			 }
	// 		 }, (err: any) => {
	// 			 reject(err);
	// 		 })
	//  })
	}

}



// WEBPACK FOOTER //
// ./src/app/services/admin.service.ts